<template>
  <div class="menu-tab-wrap">
    <div class="menu-icon" @click="menuToggle"></div>
    <div class="menu-tab-mask" v-if="isShow" @touchstart.prevent="tabClose"></div>
    <tab v-if="isShow" :show="isShow" />
  </div>
</template>

<script>
import tab from './components/tab'

export default {
  components: {
    tab
  },

  data () {
    return {
      isShow: false
    }
  },

  methods: {
    menuToggle () {
      // sa.track('NavigationBar', {
      //   navigation_location: '页面左上角'
      // })
      this.isShow = !this.isShow
    },

    tabClose () {
      this.isShow = false
    }
    
  }
}
</script>

<style lang="stylus">
  @import '../../common/styl/global'
  .menu-tab-mask
    position fixed
    top 0
    left 0
    bottom 0
    right 0
    z-index 100
    background #ffffff
    opacity 0
  .menu-tab-wrap
    width rem(28)
    height rem(28)
    position relative
    .menu-icon
      width 100%
      height 100%
      background url(//img.thebeastshop.com/images/menu-tab/menu-menu.png) no-repeat
      background-size contain

  .menu-tab-container
    position absolute
    z-index 99999
    left rem(-3)
    top rem(46)
    .menu-arrow
      width 0
      height 0
      border-top rem(8) solid transparent
      border-right rem(8) solid transparent
      border-bottom rem(8) solid #ffffff
      border-left rem(8) solid transparent
      margin-left rem(9)
      // box-shadow 0 0 rem(8) rgba(0, 0, 0, 0.12), 0 rem(8) rem(8) rgba(0, 0, 0, 0.24)
    .menu-container
      position relative
      margin-top rem(-2)
      width rem(160)
      height rem(177)
      background #ffffff
      border-radius rem(4)
      padding rem(4) 0
      box-sizing border-box
      box-shadow 0 0 rem(8) rgba(0, 0, 0, 0.12), 0 rem(8) rem(8) rgba(0, 0, 0, 0.24)
      &:before
        position absolute
        display: inline-block;
        top rem(-6)
        left rem(9)
        width 0
        height 0
        content ''
        border-style solid
        border-width rem(8)
        border-color  #fff #fff transparent transparent
        transform rotate(-45deg)
        box-shadow 0 0 rem(8) rgba(0, 0, 0, 0.12)
      .arrow-wrap
        position absolute
        display inline-block
        top 0
        left 0
        width 0
        height 0
        content ''
        border rem(16) solid #ffffff
        border-radius rem(5)
      .menu-item
        position absolute
        width 100%
        height rem(56)
        line-height rem(56)
        left 0
        top rem(4)
        clearfix()
        &:active
          background #F1F1F1
        &.second
          top rem(60)
        &.third
          top rem(116)
        .item-icon
          position absolute
          width rem(68)
          height 100%
          left 0
          top 0
          img
            position absolute
            width rem(28)
            height rem(28)
            left 50%
            top 50%
            transform translate(-50%, -50%)
        .item-text
          height 100%
          margin-left rem(68)
          border-bottom 1px solid #E1E1E1
          box-sizing border-box
          &.last
            border-bottom none
          span
            display block
            float left
            width 100%
            padding-left rem(4)
            color #000000
            font-size rem(16)
            box-sizing border-box
</style>



// WEBPACK FOOTER //
// index.vue?3085b864